import { useNavigate } from "react-router-dom";

import { MainLayout } from "~/layout";
import { ROUTES } from "~/router/routes";
import { ArrowIcon } from "~/shared/components/icons/ArrowIcon";
import { ClockIcon } from "~/shared/components/icons/ClockIcon";
import { FormContentContainer } from "../components/SignUp/FormContentContainer";

export const FailedEligibilityCheckScreen = () => {
  const navigate = useNavigate();

  return (
    <MainLayout>
      <FormContentContainer className="rounded-lg shadow-xl">
        <ClockIcon className="mb-4 size-16 self-center" />
        <div className="flex flex-col items-center text-center">
          <h1 className="font-display mb-2 text-xl">
            Unfortunately, we are not in network with that insurance.
          </h1>
          <p className="mb-12 text-gray-600">
            However, we can give you a superbill to submit to your insurance for
            potential out of network reimbursement.
          </p>
          <p className="mb-6 text-gray-600">
            Do you still want to get scheduled?
          </p>
          <button
            className="flex cursor-pointer items-center justify-end gap-2 rounded-xl bg-green-300 px-6 py-4 font-medium"
            onClick={() => {
              navigate(ROUTES.providerSelection);
            }}
          >
            <span>NEXT</span>
            <ArrowIcon direction="left" />
          </button>
        </div>
      </FormContentContainer>
    </MainLayout>
  );
};
